import { inject, Injectable } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";

@Injectable({ providedIn: 'root' })
export class NotifyService {
  private readonly message = inject(MessageService);
  private readonly confirmation = inject(ConfirmationService);
  success(detail: string) {
    this.message.add({ severity: 'success', summary: 'Éxito', detail, life: 3000 });
  }

  error(detail: string) {
    this.message.add({ severity: 'error', summary: 'Error', detail, life: 5000 });
  }

  warn(detail: string) {
    this.message.add({ severity: 'warn', summary: 'Aviso', detail, life: 4000 });
  }

  info(detail: string) {
    this.message.add({ severity: 'info', summary: 'Información', detail, life: 3000 });
  }
  confirm(message: string, header = '¿Está seguro?'): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmation.confirm({
        message,
        header,
        icon: undefined,
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'Cancelar',
        acceptButtonStyleClass: 'p-button-danger',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}